var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnMagnifyingGlass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 84 84",
    style: {
      enableBackground: "new 0 0 84 84"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M81,74.6l-22.8-23c3.9-5.4,6-11.9,6-18.7c0-8.5-3.3-16.5-9.3-22.6h0c-12.3-12.4-32.4-12.4-44.7,0 c-6,6-9.3,14-9.3,22.6s3.3,16.5,9.3,22.6c6.2,6.2,14.3,9.3,22.4,9.3c6.8,0,13.7-2.2,19.3-6.7L74.7,81c2.2,2.2,5.5,2.6,7.2,0.9 C83.7,80.1,83.3,76.8,81,74.6z M16.7,48.9c-4.2-4.3-6.6-10-6.6-16c0-6.1,2.3-11.7,6.6-16c4.4-4.4,10.1-6.6,15.9-6.6 c5.7,0,11.5,2.2,15.9,6.6c4.2,4.3,6.6,10,6.6,16c0,6.1-2.3,11.7-6.6,16C39.7,57.7,25.5,57.7,16.7,48.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnMagnifyingGlass);
export default __webpack_public_path__ + "static/media/icn_magnifying-glass.5158d5ff1362983787a4c770f525b1db.svg";
export { ForwardRef as ReactComponent };